import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import * as moment from 'moment-timezone';
import { NavigationEnd, Router } from '@angular/router';
import { gsap, Expo, Quad } from 'gsap';
import { PageDataService } from 'src/app/services/page-data.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-series-channel-page',
    templateUrl: './series-channel-page.component.html',
    styleUrls: ['./series-channel-page.component.scss']
})
export class SeriesChannelPageComponent implements OnInit {
    public today: Date
    public data: any
    public isWhereToWatchOpen: boolean = false
    public jsonData: any

    public isMobile: boolean 

    constructor(
        private router: Router,
        public pageData: PageDataService,
        private breakpointObserver: BreakpointObserver,
    ) {
        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        });

        this.today = new Date()

        this.jsonData = [
            {
                id: 'designated-survivor',
                title: 'Designated Survivor',
                path: '/channel/designated-survivor',
                bg: 'assets/img/channel/designated-survivor/designated-survivor-top-image-desktop.jpg',
                // bg: 'assets/img/channel/new/the-conners-top-image-desktop-reference.jpg',
                bgMobile: 'assets/img/channel/designated-survivor/designated-survivor-top-image-v2.jpg',
                logo: 'assets/img/channel/designated-survivor/designated-survivor-title.png',
                about: 'Tom Kirkman, a low-level cabinet member, is unexpectedly catapulted to the presidency after a catastrophic attack during the State of the Union address kills everyone above him in the line of succession.',
                aboutImage: 'assets/img/channel/designated-survivor/designated-survivor-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
                
            },
            {
                id: 'the-conners',
                title: 'The Conners',
                path: '/channel/the-conners',
                bg: 'assets/img/channel/new2/the-conners-top-image-desktop.jpg',
                // bg: 'assets/img/channel/new/the-conners-top-image-desktop-reference.jpg',
                bgMobile: 'assets/img/channel/new2/the-conners-top-image.jpg',
                logo: 'assets/img/channel/new2/the-conners-title.png',
                about: 'The Conners grapple with parenthood, dating, financial pressures, aging and in-laws in working-class America.',
                aboutImage: 'assets/img/channel/new2/the-conners-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
                
            },
            {
                id: 'nash-bridges',
                title: 'Nash Bridges',
                path: '/channel/nash-bridges',
                bg: 'assets/img/channel/new2/nash-bridges-top-image-desktop2.jpg',
                // bg: 'assets/img/channel/new/nash-bridges-top-image-desktop-reference.jpg',
                bgMobile: 'assets/img/channel/new2/nash-bridges-top-image.jpg',
                logo: 'assets/img/channel/new2/nash-bridges-title.png',
                about: 'Don Johnson is Nash Bridges, a San Francisco police investigator who deserves his reputation as the city’s top cop.',
                aboutImage: 'assets/img/channel/new2/nash-bridges-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
                
            },
            
            // {
            //     id: 'grace-and-frankie',
            //     title: 'Grace and Frankie',
            //     path: '/channel/grace-and-frankie',
            //     bg: 'assets/img/channel/new2/grace-and-frankie-top-image-desktop.jpg',
            //     // bg: 'assets/img/channel/new/grace-and-frankie-top-image-desktop-reference.jpg',
            //     bgMobile: 'assets/img/channel/new2/grace-and-frankie-top-image.jpg',
            //     logo: 'assets/img/channel/new2/grace-and-frankie-title.png',
            //     about: 'They’re not friends, but when their husbands leave them for each other, proper Grace and eccentric Frankie begin to bond.',
            //     aboutImage: 'assets/img/channel/new2/grace-and-frankie-about-image.jpg',
            //     color1: '#460cb9',
            //     color2: '#9d1b90',
            //     color3: '#f3e3f2',
            //     color4: '#fff',
                
            // },
            {
                id: 'anger-management',
                title: 'Anger Management',
                path: '/channel/anger-management',
                // bg: 'assets/img/channel/new/anger-management-top-image-desktop-reference.jpg',
                bg: 'assets/img/channel/new/anger-management-top-image-desktop.jpg',
                bgMobile: 'assets/img/channel/mobile/anger-management-top-image.jpg',
                logo: 'assets/img/channel/new/anger-management-title.png',
                about: 'Charlie Sheen stars as “Charlie,” a non-traditional therapist specializing in anger management while still battling his own anger issues.',
                aboutImage: 'assets/img/channel/anger-management-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
                // whereToWatch: [
                //     {
                //         logo: 'assets/img/streaming-logos/prime-video.png',
                //         link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/tubi.png',
                //         link: 'https://tubi.tv/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/lg-channels.png',
                //         link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/vidaa.png',
                //         link: 'https://www.vidaa.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/plex.png',
                //         link: 'https:/plex.tv/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/roku.png',
                //         link: 'https://www.roku.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                //         link: 'https://www.xumo.com/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/vizio.png',
                //         link: 'https://www.vizio.com/en/home',
                //     },

                // ]
            },
            {
                id: 'are-we-there-yet',
                title: 'Are We There Yet',
                path: '/channel/are-we-there-yet',
                bg: 'assets/img/channel/are-we-there-yet-top-image-desktop-v2.jpg',
                bgMobile: 'assets/img/channel/mobile/are-we-there-yet-top-image.jpg',
                logo: 'assets/img/channel/are-we-there-yet-title.png',
                about: 'ARE WE THERE YET? revolves around the recently blended Kingston-Person family as they work to adapt to their new family dynamics.',
                aboutImage: 'assets/img/channel/are-we-there-yet-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
                // whereToWatch: [
                //     {
                //         logo: 'assets/img/streaming-logos/prime-video.png',
                //         link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/tubi.png',
                //         link: 'https://tubi.tv/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/lg-channels.png',
                //         link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/vidaa.png',
                //         link: 'https://www.vidaa.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/plex.png',
                //         link: 'https:/plex.tv/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/roku.png',
                //         link: 'https://www.roku.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                //         link: 'https://www.xumo.com/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/vizio.png',
                //         link: 'https://www.vizio.com/en/home',
                //     },

                // ]
            },
            {
                id: 'caught-in-providence',
                title: 'Caught In Providence',
                path: '/channel/caught-in-providence',
                bg: 'assets/img/channel/caught-in-providence-top-image-desktop-v2.jpg',
                bgMobile: 'assets/img/channel/mobile/caught-in-providence-top-image.jpg',
                logo: 'assets/img/channel/caught-in-providence-title.png',
                about: 'Judge Frank Caprio takes an empathetic approach to a variety of traffic, parking and other violations.',
                aboutImage: 'assets/img/channel/caught-in-providence-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
                // whereToWatch: [
                //     {
                //         logo: 'assets/img/streaming-logos/prime-video.png',
                //         link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/tubi.png',
                //         link: 'https://tubi.tv/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/lg-channels.png',
                //         link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/vidaa.png',
                //         link: 'https://www.vidaa.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/plex.png',
                //         link: 'https:/plex.tv/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/roku.png',
                //         link: 'https://www.roku.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                //         link: 'https://www.xumo.com/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/vizio.png',
                //         link: 'https://www.vizio.com/en/home',
                //     },

                // ]
            },
            {
                id: 'celebrity-name-game',
                title: 'Celebrity Name Game',
                path: '/channel/celebrity-name-game',
                // bg: 'assets/img/channel/new/celebrity-name-game-top-image-desktop-reference.jpg',
                bg: 'assets/img/channel/new/celebrity-name-game-top-image-desktop.jpg',
                bgMobile: 'assets/img/channel/mobile/celebrity-name-game-top-image.jpg',
                logo: 'assets/img/channel/new/celebrity-name-game-title.png',
                about: 'Celebrities join contestants as they improvise clues to identify as many correct answers as possible.',
                aboutImage: 'assets/img/channel/celebrity-name-game-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
                // whereToWatch: [
                //     {
                //         logo: 'assets/img/streaming-logos/prime-video.png',
                //         link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/tubi.png',
                //         link: 'https://tubi.tv/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/lg-channels.png',
                //         link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/vidaa.png',
                //         link: 'https://www.vidaa.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/plex.png',
                //         link: 'https:/plex.tv/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/roku.png',
                //         link: 'https://www.roku.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                //         link: 'https://www.xumo.com/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/vizio.png',
                //         link: 'https://www.vizio.com/en/home',
                //     },

                // ]
            },
            {
                id: 'ghost-hunters',
                title: 'Ghost Hunters',
                path: '/channel/ghost-hunters',
                // bg: 'assets/img/channel/new/ghost-hunters-top-image-desktop-reference.jpg',
                bg: 'assets/img/channel/new/ghost-hunters-top-image-desktop.jpg',
                bgMobile: 'assets/img/channel/mobile/ghost-hunters-top-image.jpg',
                logo: 'assets/img/channel/new/ghost-hunters-title.png',
                about: 'Follow the Ghost Hunters team as they cross the country searching for answers in the nation\'s most haunted locations.',
                aboutImage: 'assets/img/channel/ghost-hunters-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
                // whereToWatch: [
                //     {
                //         logo: 'assets/img/streaming-logos/prime-video.png',
                //         link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/tubi.png',
                //         link: 'https://tubi.tv/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/lg-channels.png',
                //         link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/vidaa.png',
                //         link: 'https://www.vidaa.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/plex.png',
                //         link: 'https:/plex.tv/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/roku.png',
                //         link: 'https://www.roku.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                //         link: 'https://www.xumo.com/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/vizio.png',
                //         link: 'https://www.vizio.com/en/home',
                //     },

                // ]
            },
            {
                id: 'nashville',
                title: 'Nashville',
                path: '/channel/nashville',
                // bg: 'assets/img/channel/new/nashville-top-image-desktop-reference.jpg',
                bg: 'assets/img/channel/new/nashville-top-image-desktop.jpg',
                bgMobile: 'assets/img/channel/mobile/nashville-top-image.jpg',
                logo: 'assets/img/channel/new/nashville-title.png',
                about: 'Nashville follows the lives and tragedies of rising and fading country music stars in Nashville, Tennessee.',
                aboutImage: 'assets/img/channel/nashville-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
                // whereToWatch: [
                //     {
                //         logo: 'assets/img/streaming-logos/prime-video.png',
                //         link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/tubi.png',
                //         link: 'https://tubi.tv/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/lg-channels.png',
                //         link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/vidaa.png',
                //         link: 'https://www.vidaa.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/plex.png',
                //         link: 'https:/plex.tv/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/roku.png',
                //         link: 'https://www.roku.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                //         link: 'https://www.xumo.com/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/vizio.png',
                //         link: 'https://www.vizio.com/en/home',
                //     },

                // ]
            },
            {
                id: 'wanted-dead-or-alive',
                title: 'Wanted Dead or Alive',
                path: '/channel/wanted-dead-or-alive',
                bg: 'assets/img/channel/new/wanted-dead-or-alive-top-image-desktop.jpg',
                // bg: 'assets/img/channel/new/wanted-dead-or-alive-top-image-desktop-reference.jpg',
                bgMobile: 'assets/img/channel/mobile/wanted-dead-or-alive-top-image.jpg',
                logo: 'assets/img/channel/new/wanted-dead-or-alive-title.png',
                about: 'A Civil War veteran with a sawed-off rifle makes a living as a bounty hunter in the Wild West.',
                aboutImage: 'assets/img/channel/wanted-dead-or-alive-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
                // whereToWatch: [
                //     {
                //         logo: 'assets/img/streaming-logos/prime-video.png',
                //         link: 'https://www.amazon.com/gp/video/splash/freevee_findus',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/tubi.png',
                //         link: 'https://tubi.tv/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/lg-channels.png',
                //         link: 'https://www.lg.com/levant_en/tvs/2022/ott',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/vidaa.png',
                //         link: 'https://www.vidaa.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/plex.png',
                //         link: 'https:/plex.tv/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/roku.png',
                //         link: 'https://www.roku.com/',
                //     },
                //     {
                //         logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                //         link: 'https://www.xumo.com/',
                //     },
                    
                //     {
                //         logo: 'assets/img/streaming-logos/vizio.png',
                //         link: 'https://www.vizio.com/en/home',
                //     },

                // ]
            },
            {
                id: 'love-thy-neighbor',
                title: 'Love Thy Neighbor',
                path: '/channel/love-thy-neighbor',
                bg: 'assets/img/channel/new3/love-thy-neighbor-top-image-desktop.jpg',
                bgMobile: 'assets/img/channel/new3/love-thy-neighbor-top-image-mobile.jpg',
                logo: 'assets/img/channel/new3/love-thy-neighbor-title.png',
                about: 'Tyler Perry’s feel-good sitcom set in a family-run diner, where outspoken Hattie Mae Love dishes out laughs, love, and life lessons.',
                aboutImage: 'assets/img/channel/new3/love-thy-neighbor-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
            },
            {
                id: 'weeds-and-nurse-jackie',
                title: 'Weeds & Nurse Jackie',
                path: '/channel/weeds-and-nurse-jackie',
                bg: 'assets/img/channel/new3/weeds-nurse-jackie-top-image-desktop.jpg',
                bgMobile: 'assets/img/channel/new3/weeds-nurse-jackie-top-image-mobile.jpg',
                logo: 'assets/img/channel/new3/weeds-nurse-jackie-title.png',
                about: 'Dive into the chaotic, darkly witty worlds of suburban drug dealer Nancy Botwin and pill-popping nurse Jackie Peyton. Gritty, sharp, and addictively entertaining',
                aboutImage: 'assets/img/channel/new3/weeds-nurse-jackie-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
            },
            {
                id: 'wendy-williams',
                title: 'Wendy Williams Show',
                path: '/channel/wendy-williams',
                bg: 'assets/img/channel/new3/wendy-williams-top-image-desktop.jpg',
                bgMobile: 'assets/img/channel/new3/wendy-williams-top-image-mobile.jpg',
                logo: 'assets/img/channel/new3/wendy-williams-title.png',
                about: 'The iconic Wendy Williams talk show delivers bold, unfiltered entertainment with celebrity gossip, hot topics, hilarious moments, and unforgettable interviews.',
                aboutImage: 'assets/img/channel/new3/wendy-williams-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
            },
            {
                id: 'heartland',
                title: 'Heartland',
                path: '/channel/heartland',
                bg: 'assets/img/channel/heartland/heartland-show-top-image-desktop.jpg',
                bgMobile: 'assets/img/channel/heartland/heartland-top-image-mobile-v2.jpg',
                logo: 'assets/img/channel/heartland/heartland-title.png',
                about: 'Saddle up and ride the highs and lows of ranch life with Amy, Lou and the rest of the family.',
                aboutImage: 'assets/img/channel/heartland/heartland-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
            },
            {
                id: 'wicked-tuna',
                title: 'Wicked Tuna',
                path: '/channel/wicked-tuna',
                bg: 'assets/img/channel/wicked-tuna/wicked-tuna-show-top-image-desktop.jpg',
                bgMobile: 'assets/img/channel/wicked-tuna/wicked-tuna-top-image-mobile-v2.jpg',
                logo: 'assets/img/channel/wicked-tuna/wicked-tuna-title.png',
                about: 'A group of fishermen in Gloucester, Mass., hauls in bluefin tuna, risking danger on the high seas.',
                aboutImage: 'assets/img/channel/wicked-tuna/wicked-tuna-about-image.jpg',
                color1: '#460cb9',
                color2: '#9d1b90',
                color3: '#f3e3f2',
                color4: '#fff',
            },
        ]

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                let url = event.urlAfterRedirects
                url = url.split('?')[0]

                this.data = this.jsonData.find((item) => {
                    return item.path == url
                });



                this.animateIn();
            }
        })
    }


    animateIn() {

    }

    ngOnInit(): void {
    }

}
